// Build information, automatically generated by `ng-info`
const build = {
    version: "1.2.4",
    timestamp: "Tue Nov 03 2026 13:20:32 GMT+0200 (שעון ישראל (חורף))",
    message: null,
    git: {
        user: "NechamaFeldman",
        branch: "main",
        hash: "3a87a9",
        fullHash: "3a87a9c18950a57c04cbc98dd3a9a6d9066969e2"
    }
};

export default build;